import type {
  NavigationClassNamesType,
  NavigationPropsType,
  NavigationStylesType,
} from '@unifyapps/carbon/components/NavigationContainer/types';
import { CustomNavigation as BaseCustomNavigation } from '@unifyapps/carbon/no-code/components/CustomNavigation';
import { NavigationPosition } from '@unifyapps/defs/types/interface';

type Props = {
  interfaceRecordId: string;
  moduleId: string;
  navigationProps?: NavigationPropsType;
  navigationClassNames?: NavigationClassNamesType;
  navigationStyles?: NavigationStylesType;
};

export function CustomNav({
  interfaceRecordId,
  moduleId,
  navigationProps,
  navigationClassNames,
  navigationStyles,
}: Props) {
  if (!navigationProps || !navigationClassNames || !navigationStyles) {
    return null;
  }

  const navigation = navigationProps.navigation;
  const position = navigationProps.position ?? NavigationPosition.Start;

  return (
    <BaseCustomNavigation
      interfaceRecordId={interfaceRecordId}
      moduleId={moduleId}
      navigation={navigation}
      navigationClassNames={navigationClassNames}
      navigationStyles={navigationStyles}
      position={position}
    />
  );
}
